
import React, { Component } from 'react';
import HotKeysModal from "Components/HotKeysModal";
import { connect } from "react-redux";
import { checkAreaType } from "../../events";
import { updateAreaList } from "Store/ZoneSetting/action";
import { langCheck } from 'Pub/js/utils';

import platform from "Pub/js/platform";
import { getMultiLangText } from '../../utilService';

require('./index.less');

const { ajax, base, high } = platform;
const { Transfer } = high;
const { NCCheckbox } = base;

class AreaSync extends Component {
    constructor(props) {
        super(props);
        const { areaIndex, areaList } = props;
        this.state = {
            dataSource: this.transferData(areaList[areaIndex].queryPropertyList),
            targetKeys: [],
            isFirst: false, // first
            isSecond: false, // 卡片
        };
    }

    componentWillMount() {
        this.transferArea(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.transferArea(nextProps);
    }

    onTargetKeysChange = val => {
        this.setState({ targetKeys: val }, () => {
            console.log(this.state.targetKeys);
        });
    }

    handleConfirm = () => {

        this.syncConfirm();

        this.props.close(false);

    }

    handleCancel = () => {
        this.props.close(false);
    }

    transferData = data => {
        return data.map(item => {
            let title = getMultiLangText(item, 'label', this.props.multiOptions);
            return {
                key: item.code,
                // title: item.label || ''
                title: title || '',
            };
        });
    }
    // 区域类型
    checkAreaType = currentArea => {

        const { isFold, isTable, isSide } = checkAreaType;

        if (isFold(currentArea)) {return 'fold';}

        if (isTable(currentArea)) {return 'table';}

        if (isSide(currentArea)) {return 'side';}
    }

    // 平铺 newAreaList

    transferNewAreaList = list => {

        let arr = [];

        list.forEach(item => {
            if (item) {
                arr.push(item);
                if (Array.isArray(item.tabs)) {
                    arr = arr.concat(item.tabs);
                }
            }
        });

        return arr;
    }

    // 转化区域

    transferArea = props => {

        const { json, newAreaList, areaList, areaIndex } = props;

        const currentArea = areaList[areaIndex];

        let cNewAreaList = this.transferNewAreaList(newAreaList);

        // console.log(currentArea, 'hhhhhhhhhh')

        let areaOne = {}, areaTwo = {};

        switch (this.checkAreaType(currentArea)) {

            case 'table':

                let sides = cNewAreaList.filter(item => item).find(item => item.pk_area == currentArea.pk_area);

                areaOne.area = sides && sides.sides && sides.sides.find(item => item.areastatus == 'edit');
                areaOne.code = 'issyncside';

                areaTwo.area = sides && sides.sides && sides.sides.find(item => item.areastatus == 'browse');
                areaTwo.code = 'issyncfold';

                break;

            case 'fold':

                areaOne.area = cNewAreaList.filter(item => item).find(item => item.code == currentArea.relationcode);
                areaOne.code = 'issynclist';

                areaTwo.area = areaOne.area && areaOne.area.sides && areaOne.area.sides.find(item => item.areastatus == 'edit');
                areaTwo.code = 'issyncside';

                break;

            case 'side':

                areaOne.area = cNewAreaList.filter(item => item).find(item => item.code == currentArea.relationcode);
                areaOne.code = 'issynclist';

                areaTwo.area = areaOne.area && areaOne.area.sides && areaOne.area.sides.find(item => item.areastatus == 'browse');
                areaTwo.code = 'issyncfold';

                break;

            default:
                break;
        }

        this.setState({
            areaOne,
            areaTwo,
        });

    }

    handleCheckOne = val => {
        this.setState({ isFirst: val });
    }

    handleCheckTwo = val => {
        this.setState({ isSecond: val });
    }

    handleClickOne = () => {
        this.setState({ isFirst: !this.state.isFirst });
    }

    handleClickTwo = () => {
        this.setState({ isSecond: !this.state.isSecond });
    }

    // 同步所有 选中字段

    // 1、 覆盖本区域 选中的其他字段的 两个属性
    // 2、 其他两个区域 需要覆盖除了 这个两个属性的 所有 属性
    // 3、 字段选中 不保存状态 每次进入模态框都是 选中当前入口的字段
    // 4、 只选中当前字段 只覆盖当前 区域的

    syncConfirm = () => {

        const { isFirst, isSecond, targetKeys, areaOne, areaTwo } = this.state;

        let { areaList, updateAreaList, areaIndex } = this.props;

        // 存在区域 才进行计算更新

        if (areaOne.area || areaTwo.area) {

            areaList = _.cloneDeep(areaList);

            // 不需要覆盖的属性
            let arr = ['pk_form_property', 'pk_query_property', 'areaid', 'width', 'position', 'isnextrow', areaOne.code, areaTwo.code];

            // let currentArea, currentData, firstArea, firstData, secondArea, secondData

            // 任选其中一个区域都要进行遍历

            // 当前区域数据

            let currentArea = areaList[areaIndex];
            let currentData = currentArea ? currentArea.queryPropertyList : [];
            currentData = _.cloneDeep(currentData);

            // 第一个区域数据 如果存在的话

            // let firstArea = areaList.find(item => item.pk_area == areaOne.pk_area);
            let firstData = areaOne.area ? areaOne.area.queryPropertyList : [];
            firstData = _.cloneDeep(firstData);
            let firstCurrentItem;

            // 第二个区域数据 如果存在的话

            // let secondArea = areaList.find(item => item.pk_area == areaTwo.pk_area);
            let secondData = areaTwo.area ? areaTwo.area.queryPropertyList : [];
            secondData = _.cloneDeep(secondData);
            let secondCurrentItem;

            // 选中字段
            targetKeys.forEach(item => {

                // 1、处理当前区域的字段 无论true false 都要覆盖到同区域字段

                let currentItem = currentData.find(currentItem => currentItem.code == item);

                if (areaOne.area) {
                    currentItem[areaOne.code] = isFirst;
                }
                if (areaTwo.area) {
                    currentItem[areaTwo.code] = isSecond;
                }
                // console.log(currentItem)

                // 2、处理 其他区域字段 不处理状态值 没有此字段 做新增操作 有此字段 进行属性值覆盖

                // 第一个 区域

                if (isFirst) {

                    firstCurrentItem = firstData.find(firstItem => firstItem.code == item);

                    firstCurrentItem = _.cloneDeep(firstCurrentItem);

                    let firstToCurrentItem = _.cloneDeep(currentItem);

                    // 存在 覆盖属性处理

                    arr.forEach(delItem => {
                        delete firstToCurrentItem[delItem];
                    });

                    if (firstCurrentItem) {

                        // console.log(firstToCurrentItem)
                        // Object.assign(firstCurrentItem, firstToCurrentItem)
                        firstCurrentItem = { ...firstCurrentItem, ...firstToCurrentItem };
                        // console.log(firstCurrentItem)

                    } else {
                        // 不存在 新增处理
                        firstToCurrentItem.areaid = areaOne.area.pk_area;
                        firstToCurrentItem.pk_query_property = '';
                        firstToCurrentItem.pk_form_property = '';
                        firstCurrentItem = firstToCurrentItem;

                    }
                }

                // 第二个区域

                if (isSecond) {

                    secondCurrentItem = secondData.find(secondItem => secondItem.code == item);

                    secondCurrentItem = _.cloneDeep(secondCurrentItem);

                    let secondToCurrentItem = _.cloneDeep(currentItem);

                    // 存在 覆盖属性处理
                    arr.forEach(delItem => {
                        delete secondToCurrentItem[delItem];
                    });

                    if (secondCurrentItem) {

                        // console.log(firstToCurrentItem)
                        // Object.assign(secondCurrentItem, secondToCurrentItem)

                        secondCurrentItem = { ...secondCurrentItem, ...secondToCurrentItem };

                        // console.log(secondCurrentItem)

                    } else {
                        // 不存在 新增处理
                        secondToCurrentItem.areaid = areaTwo.area.pk_area; // 新增字段取对应区域PK
                        secondToCurrentItem.pk_query_property = ''; //
                        secondToCurrentItem.pk_form_property = '';
                        secondCurrentItem = secondToCurrentItem;

                    }
                }

                // 覆盖值
                areaList.forEach(areaItem => {
                    if (areaItem.pk_area == currentArea.pk_area) {
                        // areaItem.queryPropertyList.forEach((queryItem, index) => {
                        //     if(queryItem.code == item){
                        //         // queryItem = currentItem
                        //         areaItem.queryPropertyList[index] = currentItem
                        //     }
                        // })

                        let currentQueryItemIndex = areaItem.queryPropertyList.findIndex(queryItem => queryItem.code == item);
                        areaItem.queryPropertyList[currentQueryItemIndex] = currentItem;
                    }
                    if (areaOne.area && isFirst) {
                        if (areaItem.pk_area == areaOne.area.pk_area) {
                            let currentQueryItemIndex = areaItem.queryPropertyList.findIndex(queryItem => queryItem.code == item);
                            if (currentQueryItemIndex !== -1) {
                                areaItem.queryPropertyList[currentQueryItemIndex] = firstCurrentItem;
                            } else {
                                firstCurrentItem.position = areaItem.queryPropertyList.length + 1;
                                areaItem.queryPropertyList.push(firstCurrentItem);
                            }

                        }
                    }
                    if (areaTwo.area && isSecond) {
                        if (areaItem.pk_area == areaTwo.area.pk_area) {

                            let currentQueryItemIndex = areaItem.queryPropertyList.findIndex(queryItem => queryItem.code == item);
                            if (currentQueryItemIndex !== -1) {
                                areaItem.queryPropertyList[currentQueryItemIndex] = secondCurrentItem;
                            } else {
                                secondCurrentItem.position = areaItem.queryPropertyList.length + 1;
                                areaItem.queryPropertyList.push(secondCurrentItem);
                            }
                        }
                    }
                });

            });
            // console.log(areaList)
            // 更新数据
            updateAreaList(areaList);

        }

    }

    render() {
        const { show, areaIndex, areaList, json, multiOptions } = this.props;
        const { dataSource, targetKeys, areaOne, areaTwo, isFirst, isSecond } = this.state;
        const transferProps = {
            dataSource,
            targetKeys,
            // rowKey: 'key', // 和默认值相同时可以不指定
            rowTitle: 'title',
            rowChildren: 'children',
            treeType: false,
            onTargetKeysChange: this.onTargetKeysChange,
            checkable: true,
            className: 'sync-transfer',
            showMoveBtn: false,
            showSearch: true,
            lazy: { container: "modal" },
            listRender: ({ item, title }) => title,
            searchPlaceholder: langCheck('ZoneSetting-000276', 'pages', json),
        };
        // console.log(areaIndex, this.checkAreaType(areaList[areaIndex]))
        return (
            <HotKeysModal
                className="sync-modal"
                maskClosable={false}
                // customHeader={langCheck('ZoneSetting-000246', 'pages', json)} /* 国际化处理： 配置数据分析*/
                visible={show}
                onOk={this.handleConfirm}
                onCancel={this.handleCancel}
                okText={langCheck('ZoneSetting-000005', 'pages', json)} /* 国际化处理： 确定*/
                cancelText={langCheck('ZoneSetting-000006', 'pages', json)} /* 国际化处理： 取消*/
                width="850px"
                height="500px"
                title={langCheck('ZoneSetting-000261', 'pages', json)} /* 国际化处理： 批量设置同步*/
            // fieldid="batchSync" //自动化测试标记
            >
                <Transfer
                    {...transferProps}
                />
                <div className="sync-checkbox">
                    <div className="sync-text">
                        <span>
                            {langCheck('ZoneSetting-000265', 'pages', json)}:
                        </span>
                    </div>
                    {
                        areaOne.area && (
                            <div className="sync-checkbox-first">
                                <NCCheckbox
                                    checked={isFirst}
                                    onChange={this.handleCheckOne}
                                />
                                <span
                                    className="sync-checkbox-text"
                                    onClick={this.handleClickOne}
                                >
                                    {/* {areaOne.area.name} */}
                                    {getMultiLangText(areaOne.area, 'name', multiOptions)}
                                </span>

                            </div>
                        )
                    }
                    {
                        areaTwo.area && (
                            <div className="sync-checkbox-second">
                                <NCCheckbox
                                    checked={isSecond}
                                    onChange={this.handleCheckTwo}
                                />
                                <span
                                    className="sync-checkbox-text"
                                    onClick={this.handleClickTwo}
                                >
                                    {/* {areaTwo.area.name} */}
                                    {getMultiLangText(areaTwo.area, 'name', multiOptions)}
                                </span>
                            </div>
                        )
                    }
                </div>
                <div className="sync-tooltip">
                    {/* <div className="sync-tooltip-icon">
                        <i className="iconfont icon-zhuyi1"></i>
                    </div> */}
                    <div className="sync-tooltip-text">
                        <span>{langCheck('ZoneSetting-000262', 'pages', json)}:</span>
                        <br />
                        <span>1.{langCheck('ZoneSetting-000263', 'pages', json)};</span>
                        <br />
                        <span>2.{langCheck('ZoneSetting-000264', 'pages', json)}</span>
                    </div>
                </div>

            </HotKeysModal>
        );
    }
}

export default connect(
    state => ({
        selectedArea: state.zoneSettingData.selectedArea,
        areaList: state.zoneSettingData.areaList,
        templetid: state.zoneRegisterData.templetid,
        newAreaList: state.zoneSettingData.newAreaList,
    }),
    { updateAreaList },
)(AreaSync);
